<template>
  <div
    class="tour-page page"
  >
    <!-- 具体页面 -->
    <!-- 免责声明 -->
    <disclaimer
      class="disclaimer"
      :options="options"
      :content="require('@/imgs/index/disclaimer/bg1.png')"
    />
    <transition mode="out-in">
      <router-view
        :version="version"
      />
    </transition>
  </div>
</template>

<script>
import Disclaimer from '@/components/Disclaimer';
import { getIsFirstOpenHouse } from '@/libs/util';

export default {
  components: {
    Disclaimer,
  },
  props: {
    version: {
      type: String,
      default: 'v0',
    },
  },
  data() {
    return {
      options: {
        isFirstOpen: getIsFirstOpenHouse(),
      },
      navName: '', // 当前子路由名
    };
  },
  created() {
    // 设置正确的初始路由
    this.setRouteName();
  },
  methods: {
    onChangeGroup(group) {
      this.$router.push({ path: group });
    },
    onChangeTag(id) {
      const { navName } = this;
      if (id === navName) {
        return;
      }
      this.setRouteName();
      this.$router.push({ path: `/tour/house/${id}` });
    },
    // 设置正确的路由名
    setRouteName() {
      setTimeout(() => {
        const { path } = this.$route;
        this.$set(this, 'navName', path.split('/')[3] || '');
      }, 100);
    },
  },
};
</script>

<style lang="less" scoped>
.disclaimer {
  position: absolute;
  z-index: 100;
  right: 10px;
  bottom: 175px;
}
.v-enter{
  opacity: 0;
}
.v-enter-active{
  transition: 0.5s;
}
.v-enter-to{
  opacity: 1;
}
.v-leave{
  opacity: 1;
}
.v-leave-to{
  opacity:0;
}
.v-leave-active{
  transition: 0.5s;
}
.tour-page {
  .text-nav-bar {
    position: absolute;
    z-index: 100;
    bottom: 59px;
  }
  .tag-view {
    position: absolute;
    z-index: 11;
    left: 0;
    bottom: calc(28vh + 60px);
    animation: fade-ani 1s linear;
    .tag {
      min-width: 71px;
      // height: 24px;
      margin-bottom: 12px;
      padding: 3px 5px 6px 2px;
      box-sizing: border-box;
      background: #000000;
      opacity: 0.72;
      font-size: 10px;
      font-weight: normal;
      color: #E6E6E6;
      border-radius: 0px 10px 10px 0px;
      border: .5px solid #CDA36E;
    }
    .select-tag {
      opacity: 1;
      color: #000000;
      background: rgba(205, 163, 110, 0.9);
      border: .5px solid #EDC28B;
    }
  }
}
</style>
